export default {
  // layout
  LAYOUT: {
    sidebar: {
      ___logoTitle: 'COMPASS BIOINFORMATICS',
      ___tryButton01: 'Try',
      ___tryButton02: 'InheriNext',
      menuOption: {
        title: {
          ___phenotype: 'Phenotype',
          ___genePanel: 'Panel',
          ___disease: 'Disease',
          ___introduction: 'Introduction'
        }
      }
    },
    header: {
      ___webTitle: 'InheriNext Expert',
      ___logoTitle: 'COMPASS BIOINFORMATICS'
    },
    footer: {
      ___companyTitle: 'COMPASS BIOINFORMATICS INC.'
    },
    uploading: {
      ___default: 'Uploading'
    },
    dialog: {
      selectIdentity: {
        ___title: 'What Is Your Identity?',
        option: {
          ___patient: 'Patient or<br>Patient’s Family',
          ___doctor: 'Physicians'
        }
      },
      phenotypeMore: {
        ___title: 'Single gene result'
      },
      toast: {
        title: {
          ___success: 'Success',
          ___error: 'Error'
        },
        content: {
          ___jobFailed: 'Job failed.'
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___mainTitle: 'Inherinext Search Tools',
      introduction: {
        ___alert: 'The results from the above search tools are only for reference, not for diagnosis.',
        title: {
          ___overview: 'Overview',
          ___phenotype: 'Phenotype',
          ___genePanel: 'Gene Panel'
        },
        content: {
          ___overview01: 'This website, developed by Compass Bioinformatics Inc., provides users with search tools related to phenotypes and genes of inherited diseases. If you want to experience more comprehensive functionalities related to inherited disease detection, please try InheriNext.',
          ___overview02: 'Compass Bioinformatics Inc. is a software development company dedicated to translating genetic data into clinically useful information. InheriNext is our flagship product, providing healthcare professionals with comprehensive genetic information for better medical judgments in genetic and rare diseases.',
          ___phenotype01: 'Users can input phenotypes using Human Phenotype Ontology (HPO) numbers or terms. Our system then calculates the correlation between these characteristics and genes, displaying the most relevant diseases associated with the identified genes. Additionally, we describe the consistency between the entered phenotype and the suggested diseases.',
          ___genePanel01: 'Users can search for relevant gene panels by entering disease or phenotype terms. The system then presents a list of associated genes collected from the literature for their reference. Additionally, users have the option to download the gene list to assist in further analysis or review.'
        }
      }
    },
    genePanel: {
      ___title01: 'Enter Your Interested Disease,',
      ___title02: 'Retrieve a List of associated Genes',
      geneTag: {
        ___placeholder: 'Typing Disease or Gene panel'
      },
      introduction: {
        ___content01: 'e. g. Marfan syndrome, Leber hereditary optic neuropathy, Fabry disease, Epilepsy, Noonan and RASopathies…'
      }
    },
    phenotypeDisease: {
      ___title01: 'Provide me with Phenotypes,',
      ___title02: 'Find the most likely related Gene and Disease',
      ___selectedTitle: 'Selected',
      phenotypeTag: {
        ___placeholder: 'Typing Phenotype'
      },
      introduction: {
        ___content01: 'e. g. Global developmental delay, Short stature, Hypotonia, Nystagmus, Hearing impairment, Intellectual disability, Microcephaly…'
      },
      result: {
        ___phenotypeTitle: 'Imported Phenotypes',
        ___tableTitle: 'Results',
        alert: {
          ___content01: 'The results are only for reference,',
          ___content02: 'not for diagnosis.'
        }
      },
      table: {
        ___more: 'More',
        title: {
          ___gene: 'Gene',
          ___disease: 'Disease',
          ___phenotype: 'Phenotype Network',
          ___phenotypeMobile: 'Phe'
        }
      },
      uploading: {
        ___pleaseWait: 'Please do not leave the page and wait for a moment'
      }
    },
    resourceMap: {
      ___title: 'Resource map',
      filterOption: {
        title: {
          ___country: 'Type Country',
          ___city: 'Type City',
          ___hospital: 'Type Hospital',
          ___department: 'Type Department'
        }
      }
    }
  },
  // component
  COMPONENT: {
    resourceMap: {
      data: {
        infoOption: {
          title: {
            ___doctor: 'Doctor',
            ___address: 'Address',
            ___hospital: 'Hospital',
            ___department: 'Department'
          }
        }
      }
    },
    phenotypeDisease: {
      pathDetail: {
        text: {
          ___text01: 'It directly maps to the condition-<br>associated HPO.',
          ___text02: 'It indirectly maps to the condition-associated HPO.',
          ___text03: 'A path of similarity shows a connection from the provided HPO term to the condition-associated HPO term through <b>{length}</b> neighborhood(s).'
        }
      }
    },
    tool: {
      geneTag: {
        ___empty: 'No result has been found.',
        info: {
          ___gene: 'genes',
          ___genePanel: 'gene panels',
          ___phenotype: 'phenotypes',
          ___condition: 'conditions',
          ___add: 'add'
        },
        title: {
          ___gene: 'Genes',
          ___genePanel: 'Panels',
          ___phenotype: 'Phenotypes',
          ___condition: 'Conditions'
        }
      },
      phenotypeTag: {
        info: {
          ___phenotype: 'phenotypes',
          ___disease: 'diseases',
          ___add: 'add'
        },
        title: {
          ___phenotype: 'Phenotypes',
          ___disease: 'Diseases'
        },
        ___empty: 'No result has been found.'
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: 'Add',
      ___download: 'Download',
      ___back: 'Back',
      ___find: 'Find',
      ___search: 'Search',
      ___cancel: 'Cancel',
      ___resourceMap: 'Resource map'
    },
    toast: {
      ___noPermission: 'No Permission',
      ___pleaseLogin: 'Please Login',
      ___pageNotFound: 'Page Not Found',
      ___phenotypesAnalyzeLimit: 'More than {amount} phenotypes cannot be analyzed.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/en/lang.js